/**
 * First lines of the stanza Bach sets, entered by hand where it differs from the hymn's title
 * (the source metadata names the hymn, not the stanza). Checked against the libretto of the
 * St Matthew Passion (NBA numbering, as in the BWV 244.x catalogue numbers).
 */
export const FIRST_LINES: Record<string, string> = {
  'bwv244-15': 'Erkenne mich, mein Hüter',
  'bwv244-17': 'Ich will hier bei dir stehen',
  'bwv244-44': 'Befiehl du deine Wege',
  'bwv244-54': 'O Haupt voll Blut und Wunden',
  'bwv244-62': 'Wenn ich einmal soll scheiden',
};

/** Better-known names and a note for tunes whose source name hides them (keyed by tune-room slug). */
export const TUNE_NOTES: Record<string, { name: string; note: string }> = {
  'befiehl-du-deine-wege-melody-1': {
    name: 'Herzlich tut mich verlangen (the Passion Chorale)',
    note: 'Hans Leo Hassler’s melody (1601), sung to “O Haupt voll Blut und Wunden”, “Befiehl du deine Wege” and other hymns.',
  },
};
